import campaignPriceService from "src/services/campaignPriceService";

export const GET_CAMPAIGN_REQUEST = "@campaign/get-campaigns-request";
export const GET_CAMPAIGN_SUCCESS = "@campaign/get-campaigns-success";
export const GET_CAMPAIGN_FAILURE = "@campaign/get-campaigns-failure";

export const CREATE_CAMPAIGN_REQUEST = "@campaign/create-campaigns-request";
export const CREATE_CAMPAIGN_SUCCESS = "@campaign/create-campaigns-success";
export const CREATE_CAMPAIGN_FAILURE = "@campaign/create-campaigns-failure";

export const EDIT_CAMPAIGN_REQUEST = "@campaign/edit-campaigns-request";
export const EDIT_CAMPAIGN_SUCCESS = "@campaign/edit-campaigns-success";
export const EDIT_CAMPAIGN_FAILURE = "@campaign/edit-campaigns-failure";

export const ACTIVE_CAMPAIGN_SUCCESS = "@campaign/active-campaign-success";
export const ACTIVE_CAMPAIGN_FAILURE = "@campaign/active-campaign-failure";

export const GET_CATEGORY_REQUEST = "@campaign/get-category-request";
export const GET_CATEGORY_SUCCESS = "@campaign/get-category-success";
export const GET_CATEGORY_FAILURE = "@campaign/get-category-failure";

export const GET_DETAIL_CAMPAIGN_REQUEST = "@campaign/get-detail-campaigns-request";
export const GET_DETAIL_CAMPAIGN_SUCCESS = "@campaign/get-detail-campaigns-success";
export const GET_DETAIL_CAMPAIGN_FAILURE = "@campaign/get-detail-campaigns-failure";

export const UPDATE_CAMPAIGN_REQUEST = "@campaign/update-campaign-request";
export const UPDATE_CAMPAIGN_SUCCESS = "@campaign/update-campaign-success";
export const UPDATE_CAMPAIGN_FAILURE = "@campaign/update-campaign-failure";

export function getCampaignList(params) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_CAMPAIGN_REQUEST});
      const response = await campaignPriceService.getCampaignList(params);
      dispatch({
        type: GET_CAMPAIGN_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_CAMPAIGN_FAILURE});
      throw error;
    }
  };
}
export function createCampaignPrice(data) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_CAMPAIGN_REQUEST});
      const response = await campaignPriceService.createCampaign(data);
      dispatch({
        type: CREATE_CAMPAIGN_SUCCESS,
        payload: {response}
      });
    } catch (error) {
      dispatch({type: CREATE_CAMPAIGN_FAILURE});
      throw error;
    }
  };
}

export function editStatusCampaign(id, data) {
  return async (dispatch) => {
    try {
      dispatch({type: EDIT_CAMPAIGN_REQUEST});
      const response = await campaignPriceService.editStatusCampaign(id, data);
      dispatch({
        type: EDIT_CAMPAIGN_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: EDIT_CAMPAIGN_FAILURE});
      throw error;
    }
  };
}

export function getOneCampaignPrice(id) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_DETAIL_CAMPAIGN_REQUEST});
      const response = await campaignPriceService.getOneCampaignPrice(id);
      dispatch({
        type: GET_DETAIL_CAMPAIGN_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_DETAIL_CAMPAIGN_FAILURE});
      throw error;
    }
  };
}

export function activeCampaign(id, data) {
  return (dispatch) => {
    try {
      dispatch({
        type: ACTIVE_CAMPAIGN_SUCCESS,
        payload: {
          id,
          data
        }
      });
    } catch (error) {
      dispatch({type: ACTIVE_CAMPAIGN_FAILURE});
      throw error;
    }
  };
}

export function getCategory() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_CATEGORY_REQUEST});
      const response = await campaignPriceService.getCategory();
      dispatch({type: GET_CATEGORY_SUCCESS, payload: {response}});
    } catch (error) {
      dispatch({type: GET_CATEGORY_FAILURE});
      throw error;
    }
  };
}

export function updateCampaign(id, data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_CAMPAIGN_REQUEST});

      const response = await campaignPriceService.updateCampaign(id, data);

      dispatch({type: UPDATE_CAMPAIGN_SUCCESS, payload: {response}});
    } catch (error) {
      dispatch({type: UPDATE_CAMPAIGN_FAILURE});
      throw error;
    }
  };
}
